export function formatDecisionTitle(title: string | null | undefined): string {
  const value = title?.trim() ?? "";

  return value.replace(/([A-Za-zÁÉÍÓÚÜÑáéíóúüñ])(?=\d{1,2}\s+de\s+)/g, "$1 ");
}
